<template>
  <div class="info-videos">
    <HeroBanner
        :background-image="bannerImage"
        title="안내 영상"
        sub-title="청력 관리와 보청기 사용법을 <br>
        영상으로 쉽게 알려드립니다."
    />
    <VideoList
      :videos="videos"
      :loading="loading"
      :show-more-button="hasMore"
      @search="handleSearch"
      @load-more="loadMoreVideos"
      @video-click="handleVideoClick"
    />
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import VideoList from "@/components/VideoList.vue";
import videoListMixin from '@/mixins/videoListMixin';
import { fetchAdContentsList } from '@/api';
import bannerBg from '@/assets/images/heros/05-top-img.png';
import bannerBg2 from '@/assets/images/heros/05-top-img@2x.png';

export default {
  name: 'InfoVideos',
  components: {
    HeroBanner,
    VideoList
  },
  mixins: [videoListMixin],
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2]
    };
  },
  methods: {
    fetchAPI(params) {
      return fetchAdContentsList(params);
    },
    handleVideoClick(video) {
      // 모달 제어는 VideoList 에서 담당. 여기서는 로그만 남긴다.
      console.log('Video clicked:', video);
    }
  }
};
</script>

<style scoped lang="scss">
.info-videos {
  width: 100%;
  min-height: 55px;
}
</style>
